import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ChartElement extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }
  get value() {
    return get(this, '_wartosc.value', '');
  }

  get label() {
    const label = get(this, '_etykieta.value');
    const name = get(this, '_pracownik[0].fullName');
    return label ? label : name;
  }

  get labelIcon() {
    return get(this, '_ikonka.value[0].url', '');
  }

  get color() {
    return get(this, '_kolor.value', '');
  }

  get img() {
    return get(this, '_pracownik.value[0].photo');
  }
}



// WEBPACK FOOTER //
// ./src/models/ChartElement.js